export default __webpack_public_path__ + "static/media/icon_guide.9b80c649.svg";